import { useState, useEffect } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { getUser } from "../../../REDUX/Models/users.Model";
import { getSkills } from "../../../REDUX/Models/skills.Model";
import { getUserCertificates } from "../../../REDUX/Models/certificates.Model";
import { useSelector } from "react-redux";
import avatar from "../../../assets/icons/avatar.svg";
import Skills from "../Skills";
import Certificate from "../../../Components/Certificate";
import "../index.scss";

export default function View() {
  const { id: user_id } = useParams();
  const navigate = useNavigate();

  const isSigned = useSelector((state) => state.isSigned);

  const [user, setUser] = useState({});
  const [skills, setSkills] = useState([]);
  const [certificates, setCertificates] = useState([]);
  const [activeTab, setActiveTab] = useState("skills");

  useEffect(() => {
    if (!user_id) return navigate("/");

    if (isSigned) {
      navigate(`/profile/${user_id}`);
      return;
    }

    const fetchData = async () => {
      try {
        const userRes = await getUser(user_id);
        if (!userRes.data?.user) return navigate("/");

        setUser(userRes.data.user);

        const [skillsRes, certificatesRes] = await Promise.all([
          getSkills(user_id),
          getUserCertificates(user_id),
        ]);

        setSkills(skillsRes.data.skills || []);
        setCertificates(certificatesRes.data.certificates || []);
      } catch (err) {
        console.error("Error loading View profile:", err);
        navigate("/");
      }
    };

    fetchData();
  }, [isSigned, user_id]);

  useEffect(() => {
    if (user.first_name || user.last_name) {
      document.title = `طورنى - ${user.first_name ?? ""} ${
        user.last_name ?? ""
      }`;
    }
  }, [user]);

  return (
    <div className="profile">
      <div className="container">
        <h2 className="header">الصفحة الشخصية</h2>
        <div className="row">
          <div className="profile-img">
            <img src={avatar} alt="Profile" />
          </div>
          <div className="profile-info">
            <div className="info">
              <div className="info-header">
                <h2>
                  {user.first_name} {user.last_name}
                </h2>
                <button onClick={() => navigate("/login")}>تسجيل دخول</button>
              </div>
              <i className="fa-light fa-at"></i>
              <p>{user.user_name}</p>
            </div>
            <div className="location">
              <i className="fa-light fa-location-dot"></i>
              <p>
                {user.location ? user.location : <span>لا يوجد مدينة.</span>}
              </p>
            </div>
            <div className="rating">
              <i className="fa-solid fa-star"></i>
              <p>
                {user.rating ? (
                  <span>{`${user.rating} نجوم`}</span>
                ) : (
                  <span>لا يوجد تقيم.</span>
                )}
              </p>
            </div>
            <div className="bio">
              <i className="fa-solid fa-hashtag"></i>
              <p>{user.bio ? user.bio : <span>لا يوجد نبذة تعريفية.</span>}</p>
            </div>
          </div>
        </div>
        <div className="profile-content">
          <div className="toggle">
            {["skills", "certificates", "curriculums", "friends"].map((tab) => (
              <p
                key={tab}
                className={activeTab === tab ? "active" : ""}
                onClick={() => setActiveTab(tab)}
              >
                {tab === "curriculums" && (
                  <>
                    المناهج <i className="fa-solid fa-graduation-cap"></i>
                  </>
                )}
                {tab === "skills" && (
                  <>
                    المهارات <i className="fa-solid fa-shapes"></i>
                  </>
                )}
                {tab === "certificates" && (
                  <>
                    الشهادات <i className="fa-solid fa-file-certificate"></i>
                  </>
                )}
                {tab === "friends" && (
                  <>
                    الأصدقاء <i className="fa-solid fa-user-group"></i>
                  </>
                )}
              </p>
            ))}
          </div>

          <div className="component">
            {activeTab === "skills" && (
              <div className="profile-skills">
                {skills.length > 0 ? (
                  skills.map((skill, index) => (
                    <Skills key={index} skill={skill} />
                  ))
                ) : (
                  <span className="noData">لا يوجد مهارات للعرض.</span>
                )}
              </div>
            )}
            {activeTab === "certificates" && (
              <div className="profile-certificates">
                {certificates.length > 0 ? (
                  certificates.map((cert, index) => (
                    <Link to={`/verify/${cert.cer_id}`} className="certificate-link">
                    <Certificate key={index} certificateProp={cert} />
                    </Link>
                  ))
                ) : (
                  <span className="noData">لا يوجد شهادات للعرض.</span>
                )}
              </div>
            )}
            {activeTab === "curriculums" && (
              <div className="profile-curriculums">
                <span className="noData">
                  يجب <Link to="/login">تسجيل الدخول</Link> لعرض المناهج.
                </span>
              </div>
            )}
            {activeTab === "friends" && (
              <div className="profile-friends">
                <span className="noData">
                  يجب <Link to="/login">تسجيل الدخول</Link> لعرض الأصدقاء.
                </span>
              </div>
            )}
          </div>
        </div>

        <div className="user-contact">
          <h2>معلومات التواصل</h2>
          <div className="contact-info">
            {user.facebook && (
              <Link to={user.facebook} target="_blank">
                <div className="social-box">
                  <p>Facebook</p>
                  <i className="fa-brands fa-facebook-f"></i>
                </div>
              </Link>
            )}
            {user.twitter && (
              <Link to={user.twitter} target="_blank">
                <div className="social-box">
                  <p>Twitter</p>
                  <i className="fa-brands fa-twitter"></i>
                </div>
              </Link>
            )}
            {user.whatsapp && (
              <Link to={`https://wa.me/${user.whatsapp}`} target="_blank">
                <div className="social-box">
                  <p>Whatsapp</p>
                  <i className="fa-brands fa-whatsapp"></i>
                </div>
              </Link>
            )}
            {!user.facebook && !user.twitter && !user.whatsapp && (
              <p>لا يوجد معلومات للتواصل.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
